import { Box } from '@mui/material';
import { FC } from 'react';
import { LoadingScreen } from './LoadingScreen';
import { useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';

export const FeatureLayout: FC<{ loading?: boolean; children: any; fullHeight?: boolean }> = ({
    children,
    loading,
    fullHeight = false,
}) => {
    return (
        <Box
            sx={{
                overflow: 'auto',
                flexShrink: 0,
                bgcolor: 'background.paper',
                height: '100%',
                gridArea: 'main',
            }}
            className={fullHeight ? 'tallMain' : undefined}
        >
            {loading ? <LoadingScreen /> : children}
        </Box>
    );
};

type ExpandableFeatureLayoutProps = {
    children: React.ReactNode;
    loading?: boolean;
    fullHeight?: boolean;
    maxWidth?: string | number;
    [key: string]: any;
};

export const ExpandableFeatureLayout: FC<ExpandableFeatureLayoutProps> = ({
    children,
    loading,
    fullHeight = false,
    maxWidth,
    ...props
}) => {
    const context = useOutletContext<{ setShouldExpand?: (value: boolean) => void }>();

    useEffect(() => {
        // Tell parent to expand
        context?.setShouldExpand?.(true);

        // Reset on unmount
        return () => {
            context?.setShouldExpand?.(false);
        };
    }, []);

    return (
        <Box
            sx={{
                overflow: 'auto',
                flexShrink: 0,
                bgcolor: 'background.paper',
                height: '100%',
                gridArea: 'main',
                ...(maxWidth && {
                    '& > *': {
                        maxWidth,
                        margin: '0 auto',
                    },
                }),
            }}
            className={fullHeight ? 'tallMain' : undefined}
            {...props}
        >
            {loading ? <LoadingScreen /> : children}
        </Box>
    );
};
